import { BuiltinType } from './types';
export class BuiltinInstanceMemberStorageProperty {
    constructor(property) {
        this.property = property;
        this.types = new Set([BuiltinType.InstanceMemberValue]);
    }
    emitValue(sb, node, options, visited = false) {
        if (visited) {
            sb.emitOp(node, 'DROP');
        }
        if (options.setValue) {
            sb.emitPushString(node, this.property);
            sb.emitHelper(node, options, sb.helpers.putCommonStorage);
        }
        if (options.pushValue) {
            sb.emitPushString(node, this.property);
            sb.emitHelper(node, options, sb.helpers.getCommonStorage);
        }
    }
}

//# sourceMappingURL=BuiltinInstanceMemberStorageProperty.js.map
